module.exports = __webpack_public_path__ + "static/media/screencast-anfr-v7.b461083.webm";